import { en } from 'vuetify/locale'

import enGeneral from './en/general.ts'
import enHome from './en/home.ts'
import enShopManagement from './en/shop-management.ts'

export const additionalMessages = {
  en: {
    $vuetify: en,
    general: enGeneral,
    home: enHome,
    shopManagement: enShopManagement,
    languageName: 'English',
    selectLanguage: 'Select Language',
  },
}

export const defaultLang = 'en'
